<div class="box">
  <div class="side-padding">
    <div class="modal-header">
      <button
        type="button"
        class="close pull-right"
        title="{{ 'CLOSE' | translate }}"
        [attr.aria-label]="'CLOSE' | translate"
        (click)="hide()"
      ></button>
    </div>
  </div>

  <div class="modal-body">
    <img
      [src]="'assets/img/icons/' + img + '.svg'"
      [alt]="alt | translate"
      height="80"
      class="mx-auto mt-4"
    />

    <h2 class="text-center mt-4">{{ title | translate }}</h2>

    <p class="modal-sub-title text-center">
      {{ subTitle | translate }}
    </p>
  </div>

  <div class="modal-footer flex-column">
    <button
      type="button"
      [ngClass]="[cancelBtnClass]"
      class="button mt-1 mx-0"
      (click)="hide()"
    >
      {{ cancelBtnText | translate }}
    </button>

    <button
      type="submit"
      [ngClass]="[submitBtnClass]"
      class="button mx-0"
      (click)="hide(submitBtnEvent)"
    >
      {{ submitBtnText | translate }}
    </button>
  </div>
</div>
